<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>资金明细</el-breadcrumb-item>
          <el-breadcrumb-item>系统账单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col
            :span="4"
            class="display-row"
          >
            <div class="query-title">交易开始日:</div>
            <div class="flex1">
              <el-date-picker
                clearable
                v-model="queryInfo.createTimeStart"
                type="date"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col
            :span="4"
            class="display-row"
          >
            <div class="query-title">交易结束日:</div>
            <div class="flex1">
              <el-date-picker
                clearable
                v-model="queryInfo.createTimeEnd"
                type="date"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col
            :span="5"
            class="display-row"
          >
            <div
              class="query-title"
              style="text-align:right"
            >交易编号:</div>
            <div class="flex1">
              <el-input
                placeholder="请输入内容"
                clearable
                v-model="queryInfo.tradingNo"
                size="small"
                @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
          <el-col
            :span="5"
            class="display-row"
          >
            <div
              class="query-title"
              style="text-align:right"
            >用户ID:</div>
            <div class="flex1">
              <el-input
                placeholder="请输入内容"
                clearable
                v-model="queryInfo.userName"
                size="small"
                @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
          <el-col
            :span="6"
            class="display-row"
          >
            <div style="text-align:right;width:100%;padding-right:10px;floate:right">
              <el-button
                class="search-btn btn-gray"
                @click="queryInfoClear"
              >重置</el-button>
              <el-button
                class="search-btn btn-blue"
                @click="searchList"
              >搜索</el-button>
              <el-button class="search-btn btn-green" @click="exportAction">导出</el-button>
            </div>
          </el-col>
        </el-row>
        <div class="bill_top">
          <span class="tk-title">系统初始余额：<i>{{addThousandSeparator(systemInitBalance)}}</i>元</span>
          <span class="tk-title">收支总额：<i>{{addThousandSeparator(changeFee)}}</i>元</span>
        </div>
      </div>
      <div
        slot="table"
        class="full-height display-col"
      >
        <el-table
          :header-cell-style="tableStyle.headerStyle"
          :cell-style="tableStyle.cellStyle"
          :data="recordList"
          border
          height="550"
          :row-style="{height: '40px'}"
        >
          <el-table-column
            type="index"
            align="center"
            label="序号"
            width="40"
          ></el-table-column>
          <el-table-column
            prop="userName"
            label="用户ID"
          >
            <template v-slot="scope">
              <span>用户ID:{{ scope.row.userName }}</span>
              <p style="color: #ff0000" v-if="scope.row.clientManagerUserName">负责人:{{ scope.row.clientManagerUserName }}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="tradingNo"
            align="center"
            label="交易编号"
          >
          </el-table-column>
          <el-table-column
            prop="orderNo"
            align="center"
            label="关联订单号"
          >
          </el-table-column>
          <el-table-column
            prop="dealDesc"
            align="center"
            label="交易说明"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            sortable
            width="160"
            align="center"
            :index="indexMethod"
            label="交易时间"
          >
            <template v-slot="scope">
              {{scope.row.createTime | dateFormatToSecond}}
            </template>
          </el-table-column>
          <el-table-column
            prop="typeDetail"
            :index="indexMethod"
            sortable
            align="center"
            label="交易类型"
          >
            <template v-slot="scope">
              {{typeDetailShow(scope.row.typeDetail)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="money"
            :index="indexMethod"
            sortable
            align="center"
            label="金额"
          >
            <template v-slot="scope">
              {{ addThousandSeparator(moneyShow(scope.row.moneyFlag,scope.row.money)) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="companyBalance"
            :index="indexMethod"
            sortable
            align="center"
            label="余额"
          >
            <template v-slot="scope">
              {{ addThousandSeparator(scope.row.companyBalance) }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'
export default {
  name: '/systemCapitalRecord',
  components: { tableCon },
  data () {
    return {
      queryInfo: {
        userName: '',
        tradingNo: '',
        createTimeStart: '',
        createTimeEnd: '',
        pageSize: 10,
        pageNum: 1
      },
      orderDateRangeValue: [],
      recordList: [],
      total: 0,
      systemInitBalance: 0,
      changeFee: 0,
    }
  },
  methods: {
    async exportAction () {
      this.$http({
        url: 'cms/capitalRecord/exportSystemCapitalRecord',
        method: 'get',
        params: this.queryInfo,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
        }
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = '系统资金明细.xlsx';
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err) => {
        console.log(err);
      })
    },
    // 获取系统收支
    getSystemChangeFee () {
      this.$http.get("cms/capitalRecord/system/changeFee").then(res => {
        if (res.data.code === 200) {
          this.changeFee = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
      this.getSystemChangeFee();
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
      this.getSystemChangeFee();
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    orderDateRange () { },
    searchList () {    //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
      this.getSystemChangeFee();
    },
    async getrecordList () {
      const { data: res } = await this.$http.get('cms/capitalRecord/systemList', { params: this.queryInfo });
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    queryInfoClear () {    //清空
      this.queryInfo = {
        createTimeStart: '',
        createTimeEnd: '',
        tradingNo: '',
        userName: '',
        pageSize: 10,
        pageNum: 1
      }
      this.orderDateRangeValue = [];
    },
    typeDetailShow (status) {
      switch (status) {
        case '1':
          return '充值'
        case '2':
          return '装箱单付款'
        case '2+':
          return '国际运费退回'
        case '3':
          return '订单付款'

        case '4':
          return '赔偿'

        case '5':
          return '扣款'

        case '6':
          return '退金（提现）'

        case '7':
          return '购买完扣费'

        case '8':
          return '退货退费'

        case '9':
          return '异常扣费'

        case '10':
          return '同捆付款'

        case '11':
          return '仓库保管费'

        case '12':
          return '检品完扣费'

        case '13':
          return '取消购买退费'

        case '14':
          return '取消检品退费'

        case '16':
          return '仓储费'

        case '16+':
          return '仓储费退费'

      }
    },
    moneyShow (moneyFlag, money) {
      switch (moneyFlag) {
        case '1':
          return '-' + money

        case '0':
          return '+' + money

      }
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    orderDateRangeValue () {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.orderDateRangeValue) {
        this.orderDateRangeValue = [];
        this.queryInfo.createTimeStart = '';
        this.queryInfo.createTimeEnd = '';
      }
      else {
        if (this.orderDateRangeValue.length > 0) {
          this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
          this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
        }
      }
    }
  },
  created () {
    this.getrecordList();
    this.getSystemChangeFee();
  }
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
.bill_top {
  // width: 100%;
  height: 20px;
  margin: 10px;
  padding-right: 15px;
  padding-top: 15px;
  float: right;
}
.bill_top span {
  display: block;
  float: left;
  margin-left: 20px;
}
.bill_top i {
  text-decoration: underline;
  color: black;
  font-style: normal;
  padding-right: 5px;
}
.tk-title {
  color: #999999;
}
</style>
